import * as React from 'react';
import { Checkbox } from './checkbox';

export namespace AmountSelector {
	export interface Props {
		onChange: (value: number) => void;
		defaultValue: number;
		id: string;
		disabled: boolean;
	}

	export interface State {
		checked: boolean;
	}
}

export class AmountSelector extends React.Component<AmountSelector.Props, AmountSelector.State> {

	constructor(props: AmountSelector.Props) {
		super(props);

		this.state = {
			checked: props.defaultValue > 0
		}
	}

	activateNumber = (e: any) => {
		if(e.target.checked === false){
			this.changeValue(0);
		}else{
			this.changeValue(1);
		}
		this.setState({checked: e.target.checked});
	}

	changeValue = (e: any) => {
		const { onChange } = this.props;
		if(e.target)
			onChange(parseInt(e.target.value));
		else if(!isNaN(e)){
			onChange(e);
		}
	}

	render () {
		const {id, defaultValue, disabled} = this.props;
		const {checked} = this.state;

		let numberInput;

		const value = defaultValue === 0 ? '1' : ''+defaultValue;

		if(checked || disabled) numberInput = <input type="number" onChange={this.changeValue} defaultValue={value} min={1} max={9}/>

		return (
			<div className="am_amountSelector">
				{ numberInput }
				<Checkbox onChange={this.activateNumber} id={id} checked={checked || disabled} disabled={disabled}/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/amountSelector.tsx